import { GetListRequestParams, GetListResponse, instance } from "libs/api";

import { InventoryManagerListItem } from "../../inventory.types";
import { ApiRoutesInventory } from "./../../constants";

export const requestGetInventoryManagers = async (
  params: GetListRequestParams
): Promise<GetListResponse<InventoryManagerListItem>> => {
  return await instance.get(ApiRoutesInventory.AllInventoryManagers, {
    params
  });
};
